import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Typography } from '@mui/material';
import { useMemo } from 'react';
import { useTimeBucketSelector } from '../../../hooks/useTimeBucketSelector';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const useTimeBucketSelectorWidget = () => {
    const { components } = useTimeBucketSelector({});
    const component = useMemo(() => (_jsxs(Stack, { gap: 1, children: [_jsx(Typography, { variant: "h5", children: "width" }), components.width, _jsx(Typography, { variant: "h5", children: "unit" }), components.unit] })), [components]);
    return {
        name: 'useTimeBucketSelector',
        category: 'hooks',
        component,
    };
};
